module.exports = __webpack_public_path__ + "static/media/final3.847bb92a.jpg";